import React, { useState } from "react";
import PdfEditor from "./PdfEditor"; // Import the PdfEditor component
import SecondaryButton from "../../buttons/SecondaryButton";
import Modal1 from "../../modals/Modal1";

const PdfEditorModal = ({
  folder,
  document,
  file_url = null,
  onFetch,
  userData,
}) => {
  const [open, setOpen] = useState(false);

  // Handlers to open and close the modal
  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const handleonFetch = () => {
    onFetch();
    handleClose();
  };

  const formulaireConsentementUrl =
    "https://storage.googleapis.com/foundry-2dlu01.appspot.com/Formulaire_consentement_DPE_VIERGE_2.pdf";

  return (
    <div className=" justify-end w-fit">
      {/* Button to open the modal */}
      <SecondaryButton onClick={handleOpen} className={"w-fit "}>
        Préparer la signature
      </SecondaryButton>

      {/* Modal that contains the PdfEditor */}
      <Modal1 isOpen={open} onClose={handleClose}>
        <div className="p-4 rounded-xl w-screen h-screen">
          <PdfEditor
            file_url={
              document?.documentxx?.id === "IGjNsygZZjmq7ucUirV6"
                ? formulaireConsentementUrl
                : file_url
            }
            folder={folder}
            document={document}
            onClose={handleClose}
            onFetch={handleonFetch}
            userData={userData}
          />{" "}
        </div>
        {/* This is where the PdfEditor will be rendered */}
      </Modal1>
    </div>
  );
};

export default PdfEditorModal;
